import { createContext } from 'react';
import type { MetricKey, SortState } from './utils';

interface MetricHoverContextValue {
  hoveredMetricKey: MetricKey | null;
  setHoveredMetricKey: (metricKey: MetricKey | null) => void;
}

interface MetricSortContextValue {
  sortState: SortState | null;
}

export const MetricHoverContext = createContext<MetricHoverContextValue>({
  hoveredMetricKey: null,
  setHoveredMetricKey: () => undefined,
});

export const MetricSortContext = createContext<MetricSortContextValue>({
  sortState: null,
});
